export type WealthCoachStage =
  | 'ProfileComplete'
  | 'Calendar'
  | 'ReturningCustomer';
